import { useRouter } from "next/router";
import { useLang } from "contexts/lang-context";
import { localizedUrl } from "lib/seo";

const LangSwitch = () => {
  const router = useRouter();
  const { urls, labels } = useLang();
  const label = router.locale === "tr-tr" ? "Dil:" : router.locale === "nl-be" ? "Taal:" : "Language:";
  const options = labels.filter((item: any) => item.locale === router.locale ||
    urls.some((target: any) => target.locale.toLowerCase() === item.locale));

  const handleChange = (langCode: string) => {
    if (router.locale === langCode) return;
    const target = urls.find((item: any) => item.locale.toLowerCase() === langCode);
    if (!target) return;
    const href = localizedUrl(target.url, langCode);
    if (!href) return;
    const url = new URL(href);
    const query = typeof router.query.q === "string" ? router.query.q : "";
    if (query) url.searchParams.set("q", query);
    const crossDomain = (router.locale === "tr-tr") !== (langCode === "tr-tr");
    if (crossDomain) window.location.assign(url.toString());
    else router.push({ pathname: target.url, query: query ? { q: query } : {} }, undefined, { locale: langCode });
  };

  return (
    <div className="lang-switch">
      <label htmlFor="site-language">{label}</label>
      <span className="lang-switch__control">
        <select id="site-language" value={router.locale} onChange={(event) => handleChange(event.target.value)}>
          {options.map((item: any) => <option key={item.locale} value={item.locale}>{item.name}</option>)}
        </select>
        <svg className="lang-switch__chevron" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
          <path d="m4 6 4 4 4-4" />
        </svg>
      </span>
    </div>
  );
};
export default LangSwitch;
